import { getProperty } from 'customer-data-objects/model/ImmutableModel';
import { CREATED_BY } from 'customer-data-objects/task/TaskPropertyNames';
// @ts-expect-error untyped
import { isError, isLoading } from 'reference-resolvers/utils';
// @ts-expect-error untyped
import { USER } from 'reference-resolvers/constants/ReferenceObjectTypes';
// @ts-expect-error untyped
import ResolveReferences from 'reference-resolvers/ResolveReferences';
import get from 'transmute/get';
import { jsx as _jsx } from "react/jsx-runtime";
function UserLabel({
  resolvedUser
}) {
  if (isLoading(resolvedUser) || isError(resolvedUser)) {
    return null;
  }
  return get('label', resolvedUser);
}
const mapResolversToProps = (resolvers, props) => {
  return {
    resolvedUser: resolvers[USER].byId(props.userId)
  };
};
const ResolvedUserLabel = ResolveReferences(mapResolversToProps)(UserLabel);
const TaskCreatedByCell = ({
  original: task
}) => {
  const createdByUserId = Number(getProperty(task, CREATED_BY));
  if (!createdByUserId) {
    return /*#__PURE__*/_jsx("div", {
      children: "--"
    });
  }
  return /*#__PURE__*/_jsx(ResolvedUserLabel, {
    userId: createdByUserId
  });
};
export default TaskCreatedByCell;